<div class="rms-mod-host"
     [class.flippable]="isFlip"
     [class.morphable]="isMorph"
     [class.flipped]="isFlip && flipped"
     [@morphSize]="isMorph ? morphSizeBinding : null"
     [ngStyle]="{
       width: (isMorph ? '' : (width)),
       height: height,
       minHeight: minHeight,
       maxHeight: maxHeight
     }">

  @if(includeHeader){
  <section class="mod-header">
    <ng-content select="[mod-header]"></ng-content>
  </section>
  <hr />
  }

  @if(flippable){
  <section class="rms-mod-face rms-mod-front"
           [@morphFrontFade]="frontFaceBinding">
    <ng-content select="[mod-front]"></ng-content>
  </section>

  <section class="rms-mod-face rms-mod-back"
           [@morphBackFade]="backFaceBinding">
    <ng-content select="[mod-back]"></ng-content>
  </section>
  }
  @else{
  <ng-content></ng-content>
  }
</div>
@if(backButton){
<button (click)="onBackButtonClick()" class="mod-back-button btn-bg-red" mat-icon-button><mat-icon>arrow_back</mat-icon></button>
}
